import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HelmetWrapper from "../../HelmetWrapper";
import { Col, Container, Row } from "react-bootstrap";
import PageHeadingNew from "../common-components/custom-comps/PageHeadingNew";
// import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import CmnFilters from "../lead-management/common/CmnFilters";
import { fetchAcademyLeadsData } from "../../redux/prospect-reducers/prospectSlice";
import "../../styles/lead-mangement/academy-leads.css";
import TableSkeleton from "../common-components/TableSkeleton";
import { formatDateTime } from "../common-data/Converts";

const AcademyLeadsStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const token = userInfoData?.token;
  const { academyLeads, academyLeadsLoading } = useSelector(
    (state) => state?.prospects
  );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilters = {
    searchString: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit,
    search: "",
    date_from: "",
    date_to: "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setFilters(iniFilters);
    setIsPage(0);
    setSearchFilterApplied(false);
  };

  useEffect(() => {
    dispatch(
      fetchAcademyLeadsData({
        filters: filters,
        token: token,
      })
    );
  }, [dispatch, filters, token]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
    }));
  }, [isPage, pageLimit, allFilters.leadAddDateFrom, allFilters.leadAddDateTo]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "name",
      text: "Staff",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer">
          <span className="tb-data text-start">
            {row?.name || "NA"}
            <br />
            {(row?.mobile || row?.email) && (
              <small className="lowercase underline">
                {row?.mobile || ""}
                <br />
                {row?.email || ""}
              </small>
            )}
          </span>
        </div>
      ),
    },
    {
      dataField: "title",
      text: "Course Title",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.title || "NA"}</span>
        );
      },
    },
    {
      dataField: "duration",
      text: "Duration (Days)",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.duration || "NA"}
          </span>
        );
      },
    },
    // {
    //   dataField: "name",
    //   text: "Student Name",
    //   formatter: (_, row) => {
    //     return <span className="tb-data minWidth150">{row?.name || "NA"}</span>;
    //   },
    // },
    // {
    //   dataField: "email",
    //   text: "Email",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data minWidth200 lowercase">
    //         {row?.email || "NA"}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "mobile",
    //   text: "Mobile",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data minWidth120">{row?.mobile || "NA"}</span>
    //     );
    //   },
    // },
    {
      dataField: "city",
      text: "City",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.city || "NA"}</span>;
      },
    },
    {
      dataField: "pincode",
      text: "Pincode",
      formatter: (_, row) => {
        return (
          <span className="tb-data">{row?.pincode || "-"}</span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTime(row.date_added) : "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Academy Leads">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <PageHeadingNew
              heading="Academy Leads"
              subheading="Manage Academy Leads"
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"academy-leads"}
              userInfoData={userInfoData}
              onClickReset={onClickReset}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              searchPlaceHolder="Search by course title, student name, email..."
            />
          </Col>
        </Row>

        <Row className="mt-4">
          <Col>
            <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mod-height-100vh">
              {academyLeadsLoading ? (
                <TableSkeleton />
              ) : (
                <PaymentLinkTable
                  tableData={academyLeads?.data || []}
                  tableColumns={tbColumns}
                  tablePagination={academyLeads?.pagination}
                  isPage={isPage}
                  setIsPage={setIsPage}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default AcademyLeadsStructure;
